"use client";

import Image from "next/image";
import { ComponentProps } from "react";
import { crossDomainImageLoader } from "src/utils/images";

type Props = ComponentProps<typeof Image>;

export const CrossDomainImage = ({ ...props }: Props) => {
  return <Image {...props} loader={crossDomainImageLoader} />;
};
